import { useTranslation } from "react-i18next";
import './UpgradeNonSuite.css';
import { useState } from "react";
import UpgradeNonSuitePopup from "./UpgradeNonSuitePopup/UpgradeNonSuitePopup";
import UpgradeButton from "../Payment/UpgradeSubscription/UpgradeButton/UpgradeButton";

const UpgradeNonSuite = () => {
    const { t } = useTranslation();
    const [showUpgradePopup, setShowUpgradePopup] = useState<boolean>(false);

    return(
        <>
            {
                showUpgradePopup && 
                <UpgradeNonSuitePopup
                    onClose={() => { setShowUpgradePopup(false) }}/>
            }
            <div className="d-flex align-items-center">
                <div className="right-align-container2">
                    <UpgradeButton
                        onClick={() => { setShowUpgradePopup(true) }}
                        text={t('Upgrade')}
                    />
                </div>
            </div>
        </>
    );
}

export default UpgradeNonSuite;